module.exports = __webpack_public_path__ + "img/Arrow-White.9481d9ef.svg";